import { BannerContentInlineStyles, BannerHeaderInlineStyles, BannerFooterInlineStyles, BannerHeader, BannerBody, BannerFooter } from ".";
import { useBanner } from "../../contexts";

var BannerContent = function BannerContent() {
  var banner = useBanner();
  /*const { ref } = usePerfectScrollbar({
      parentContainer: `#${pageRequestUuid4}`,
      thumbColor: `${fontColor}4d`
  });*/

  return h("div", BannerContentInlineStyles.content(banner), h(BannerHeader, null), h("div", BannerHeaderInlineStyles.headerSeparator(banner)), h(BannerBody, null), h("div", BannerFooterInlineStyles.footerSeparator(banner)), h(BannerFooter, null));
};

export { BannerContent };